import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FieldType, FormlyFieldProps } from '@ngx-formly/bootstrap/form-field';
import { FieldTypeConfig } from '@ngx-formly/core';
import { Button } from 'primeng/button';

interface ButtonProps extends FormlyFieldProps {
  clickFunction?: string;
}

// noinspection CssUnknownTarget
@Component({
  selector: 'app-button-field',
  template: `
    <p-button
      class="d-block mb-3"
      styleClass="button-basic button-secondary"
      [label]="props.label"
      (click)="buttonClick()"></p-button>
  `,
  imports: [Button],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonFieldComponent extends FieldType<
  FieldTypeConfig<ButtonProps>
> {
  public buttonClick() {
    if (this.props.clickFunction) {
      const evalFunction: any = eval(this.props.clickFunction);
      evalFunction(this.field);
    }
  }
}
